




































import { Audit } from '@empathybroker/tsclient-play/dist/models/audit';

import { Location, Route } from 'vue-router';
import { mapActions, mapGetters } from 'vuex';

import { AuditEntry, UiButton, UiTextbox } from '../components';

import { ApiEnum, AuditSortFieldEnum, PeriodEnum, SortDirectionEnum } from '../enums';

import { GuardResolveFunction } from '../models';

import { ROUTER_CONSTS } from '../router/router.consts';

import { AUDIT_CONSTS } from '../store/audit/audit.consts';
import { CONTEXT_CONSTS } from '../store/context/context.consts';

import { DateUtils } from '../utils';

interface AuditsGroup {
  id: string;
  label: string;
  items: Audit[];
}

export default {
  name: 'audit',
  props: {
    loading: Object
  },
  components: {
    UiTextbox,
    AuditEntry,
    UiButton
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    }),
    ...mapGetters(AUDIT_CONSTS.moduleName, {
      data: AUDIT_CONSTS.getters.data
    }),
    auditsGroups: function (): AuditsGroup[] {
      return this.data.items.reduce((auditsGroups: AuditsGroup[], audit: Audit) => {
        const auditGroupId = this.getAuditGroupId(audit);
        const auditsGroup = auditsGroups.find((group: AuditsGroup) => (group.id === auditGroupId));
        if (!auditsGroup) {
          auditsGroups.push({
            id: auditGroupId,
            label: this.getAuditGroupLabel(audit),
            items: [audit]
          });
        } else {
          auditsGroup.items.push(audit);
        }
        return auditsGroups;
      }, []);
    }
  },
  data: function () {
    return {
      pagination: {
        page: 1,
        itemsPerPage: 10
      },
      sort: {
        field: AuditSortFieldEnum.DATE,
        direction: SortDirectionEnum.DESCENDING
      },
      expandedAuditId: undefined,
      contextWatchDisabled: false,
      messages: this.$epb.messages.audit
    };
  },
  methods: {
    ...mapActions(CONTEXT_CONSTS.moduleName, {
      setQuery: CONTEXT_CONSTS.actions.setQuery
    }),
    ...mapActions(AUDIT_CONSTS.moduleName, {
      list: AUDIT_CONSTS.actions.list
    }),
    onQueryChange: async function (): Promise<void> {
      const inputEl: HTMLInputElement = (this.$refs.searchbox.$refs.input as HTMLInputElement);
      await this.setQuery(inputEl.value || undefined);
      this.$emit('contextChanged');
    },
    getAuditGroupId: function (audit: Audit): string {
      const auditGroupValue = audit[this.sort.field];
      if (this.sort.field === AuditSortFieldEnum.DATE) {
        const auditGroupDate = new Date(auditGroupValue);
        auditGroupDate.setUTCHours(0, 0, 0, 0);
        return auditGroupDate.toISOString();
      }
      return auditGroupValue;
    },
    getAuditGroupLabel: function (audit: Audit): string {
      const auditGroupValue = audit[this.sort.field];
      if (this.sort.field === AuditSortFieldEnum.DATE) {
        return this.getDateLabel(auditGroupValue);
      }
      return auditGroupValue;
    },
    getDateLabel: function (date: Date): string {
      const dateGroupsMessages = this.messages.sort[AuditSortFieldEnum.DATE].groups;
      const today = new Date();
      const yesterday = new Date(new Date().setDate(today.getDate() - 1));
      if (DateUtils.isSamePeriod(PeriodEnum.DAY, date, today)) {
        return dateGroupsMessages.today;
      } else if (DateUtils.isSamePeriod(PeriodEnum.DAY, date, yesterday)) {
        return dateGroupsMessages.yesterday;
      } else {
        return date.toLocaleString(this.$epb.locale, {
          year: 'numeric',
          month: 'long',
          weekday: 'short',
          day: 'numeric'
        });
      }
    },
    onToggleAuditExpand: function (auditId: string): void {
      this.expandedAuditId = (this.expandedAuditId !== auditId) ? auditId : undefined;
    },
    loadData: async function (resetPagination = false): Promise<void> {
      if (resetPagination) {
        this.pagination.page = 1;
      }
      this.$emit('updateLoading', { visible: true });
      try {
        await this.list({
          pagination: this.pagination,
          sort: this.sort
        });
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.PLAY));
      } finally {
        this.$emit('updateLoading', { visible: false });
      }
    },
    onLoadMoreClick: function (): void {
      this.pagination.page++;
      this.loadData();
    }
  },
  beforeRouteLeave: async function (to: Route, from: Route, next: GuardResolveFunction): Promise<void> {
    this.contextWatchDisabled = true;
    let redirectLocation: Location;
    if (!!this.context.query) {
      await this.setQuery(undefined);
      redirectLocation = {
        ...to,
        query: {
          ...to.query,
          [ROUTER_CONSTS.query.query]: undefined
        }
      };
    }
    next(redirectLocation);
  },
  watch: {
    context: {
      handler: async function (): Promise<void> {
        if (!this.contextWatchDisabled) {
          await this.loadData(true);
        }
      },
      deep: true,
      immediate: true
    }
  }
};

